import { FetchHomePageOptionsActionTypes } from '../actions/NavConfigActions';
import { handleActions } from 'flux-actions';
const initialState = [];
export default handleActions({
  [FetchHomePageOptionsActionTypes.SUCCESS](state, action) {
    return action.payload.data;
  }
}, initialState);